<template>
    <div>

        <div id="ag-grid-container-user-transfers">
            <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                :gridOptions="gridOptions"
                @row-double-clicked="(params) => editTransferConfig(params.data)"
                :groupHeaders="true"
                :rowHeight="40">
            </ag-grid-vue>
        </div>
        <template v-if="showGrid">
            <v-btn color="#c42111" class="mt-3 mr-3" @click="createTransferConfig">New</v-btn>
            <v-btn color="#c42111" class="mt-3 mr-3" @click="$emit('cancel')">Back</v-btn>
        </template>

        <v-dialog v-model="showTransferConfigurationEdit" width="1200px" max-width="80%" persistent @keydown="(k) => {k.key == 'Escape' ? showTransferConfigurationEdit = false : null}" v-if="showTransferConfigurationEdit">
            <transfer-configuration-edit :configClone="selectedTransferConfiguration" :userThresholdList="$props.userThresholdList" @save="saveTransferConfig" @cancel="showTransferConfigurationEdit = false"></transfer-configuration-edit>
        </v-dialog>

        <v-dialog v-model="showRunTransferConfigModal" width="400px" max-width="80%" persistent @keydown="(k) => {k.key == 'Escape' ? showRunTransferConfigModal = false : null}" v-if="showRunTransferConfigModal">
            <v-card>
                <v-card-title>Are you sure?</v-card-title>
                <v-card-text>
                    <span v-html="`Are you sure you want to run User Threshold reports for <b>${selectedRunTransferConfig.transfer_name}</b> transfer configuration now?`"></span>
                    <v-row>
                        <v-col cols="12" class="mt-4">
                            <v-menu v-model="editInstantRunDate" :close-on-content-click="true" transition="scale-transition" offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="instantRunDate" color="#c42111" label="Run for Date" prepend-icon="event" readonly v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="instantRunDate" color="#c42111" scrollable />
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn text @click="showRunTransferConfigModal = false; selectedRunTransferConfig = null;">Cancel</v-btn>
                    <v-btn text @click="runTransferConfig">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import TransferConfigurationEdit from '@/components/UserThresholds/TransferConfigurationEdit';
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";

export default {
    name: 'TransferConfigurationList',
    props: ['userThresholdList'],
    components: {
        'ag-grid-vue': AgGridVue,
        TransferConfigurationEdit
    },
    data: () => ({
        showGrid: false,
        showTransferConfigurationEdit: false,
        selectedTransferConfiguration: null,
        userTransferList: [],

        selectedRunTransferConfig: null,
        showRunTransferConfigModal: false,
        instantRunDate: null,
        editInstantRunDate: false
    }),

    computed: {

    },

    methods: {
        getUserTransferList: function() {
            let route = (TELSA.apiHost + "userthreshold/usertransferlist");
            this.showGrid = false;
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.userTransferList = result.data.user_transfer_list;
                this.buildAgGrid();
                TELSA.loading(false);
            });
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.userTransferList;
            this.gridOptions.columnDefs = this.createColumnDefs();

            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'transferConfigurationList');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            // Set the row text color if the current time is outside the rules active times.
            this.gridOptions.getRowStyle = function(params) {
                if(!!params.data.schedules[0].start_date && !!params.data.schedules[0].end_date) {
                    let start = TELSA.moment(params.data.schedules[0].start_date);
                    let end = TELSA.moment(params.data.schedules[0].end_date);
                    let current = TELSA.moment.tz(self.$store.state.batchConfig.timezone);
                    if(current < start) { // Rule hasnt started yet
                        return {
                            fontWeight: 'bold',
                            color: 'limegreen'
                        };
                    }
                    if(current > end) { // Rule has expired
                        return {
                            fontWeight: 'bold',
                            color: 'red'
                        };
                    }
                    // Otherwise the rule is active now
                }
            }

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 150, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle user-tres-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle user-tres-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span class="mdi mdi-play-circle user-tres-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span class="mdi mdi-content-copy user-tres-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);
                            this.runButtonHandler = this.runButtonHandler.bind(this);
                            this.cloneButtonHandler = this.cloneButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.user-tres-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.user-tres-action')[1];
                            this.runButton = this.eGui.querySelectorAll('.user-tres-action')[2];
                            this.cloneButton = this.eGui.querySelectorAll('.user-tres-action')[3];
                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                            this.runButton.addEventListener('click', this.runButtonHandler);
                            this.cloneButton.addEventListener('click', this.cloneButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        runButtonHandler(event) {
                            event.stopPropagation();
                            this.params.runFunction(this.params);
                        }
                        cloneButtonHandler(event) {
                            event.stopPropagation();
                            this.params.cloneFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                            this.runButton.removeEventListener('click', this.runButtonHandler);
                            this.cloneButton.removeEventListener('click', this.cloneButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            this.editTransferConfig(params.data);
                        },
                        deleteFunction: (params) => {
                            this.deleteTransferConfigClick(params.data.transfer_id);
                        },
                        runFunction: (params) => {
                            this.runTransferConfigClick(params.data);
                        },
                        cloneFunction: (params) => {
                            this.cloneTransferConfigClick(params.data);
                        }
                    }
                },
                { 
                    headerName: 'Transfer Name', 
                    field: 'transfer_name', 
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'User Thresholds', 
                    field: 'user_thresholds', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.user_thresholds.map(x => self.$props.userThresholdList.find(ut => ut.thres_id == x).thres_name).toString();
                    }
                },
                { 
                    headerName: 'Protocol', 
                    field: 'protocol', 
                    width: 60, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        let protocolList = [{text: 'FTP', value: 'ftp'}, {text: 'SFTP', value: 'sftp'}, {text: 'SMTP', value: 'smtp'}, {text: 'Web/Samba', value: 'samba'}];
                        if(!params.data) {
                            return;
                        }
                        return protocolList.find(p => p.value == params.data.protocol).text;
                    },
                },
                { 
                    headerName: 'Format', 
                    field: 'file_format', 
                    width: 60, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Host', 
                    field: 'dest_host', 
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Folder', 
                    field: 'dest_folder', 
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Compress', 
                    field: 'compress', 
                    width: 60, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Percent to Decimal', 
                    field: 'percent_to_decimal', 
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Recipients', 
                    field: 'recur_type', 
                    width: 60, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.recipients.length;
                    }
                },
                { 
                    headerName: 'Recurs', 
                    field: 'recur_type', 
                    width: 70, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return TELSA.upperFirstCharacter(params.data.schedules[0].recur_type);
                    }
                },
                { 
                    headerName: 'Frequency', 
                    field: 'repeat_frequency', 
                    width: 70, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.schedules[0].repeat_frequency;
                    }
                },
                { 
                    headerName: 'Time', 
                    field: 'recur_time', 
                    width: 70, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.schedules[0].recur_time;
                    }
                },
                { 
                    headerName: 'Repeat On', 
                    field: 'repeat_on', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        if(params.data.schedules[0].recur_type == 'weekly' && params.data.schedules[0].repeat_on) {
                            let value = params.data.schedules[0].repeat_on;
                            let orderedDays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                            let orderedValue = [];
                            orderedDays.forEach(day => {
                                if(value.includes(day)) {
                                    orderedValue.push(day);
                                }
                            });
                            return orderedValue.toString();
                        }
                        else {
                            return params.data.schedules[0].repeat_on;
                        }
                    }
                },
                { 
                    headerName: 'Start Date', 
                    field: 'start_date', 
                    width: 70, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.schedules[0].start_date;
                    }
                },
                { 
                    headerName: 'End Date', 
                    field: 'end_date', 
                    width: 70, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.schedules[0].end_date;
                    }
                },
                { 
                    headerName: 'Next Transfer Time', 
                    field: 'next_transfer_datetime', 
                    width: 110, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.next_transfer_datetime;
                    }
                },
            ];
            return columnDefs;
        },

        createTransferConfig: function() {
            let transferConfiguration = {
                transfer_id: -1,
                transfer_name: "",
                user_thresholds: [],
                compress: false,
                dest_folder: "",
                dest_host: "",
                file_format: "excel",
                password: "",
                percent_to_decimal: false,
                port: 21,
                protocol: "ftp",
                username: "",
                schedules: [{
                    recur_type: 'daily',
                    recur_time: "00:00:00",
                    repeat_frequency: "1",
                    repeat_on: null,
                    start_date: TELSA.moment().format('YYYY-MM-DD'),
                    end_date: ""
                }],
                recipients: []
            };
            this.selectedTransferConfiguration = transferConfiguration;
            this.showTransferConfigurationEdit = true;
        },

        editTransferConfig: function(transferConfiguration) {
            // clone the transfer config so we're not modifying the real one until they save it.
            this.selectedTransferConfiguration = JSON.parse(JSON.stringify(transferConfiguration));


            this.selectedTransferConfiguration.recipients = this.selectedTransferConfiguration.recipients.map(r => {
                if(r.user_id) {
                    let user = this.$store.state.batchConfig.users.find(u => u.user_id == r.user_id);
                    return {
                        ...user,
                        type: 'user',
                        search: `${user.user_username}${user.user_fullname}`
                    };
                }
                else if(r.group_id) {
                    let group = this.$store.state.batchConfig.groups.find(g => g.group_id == r.group_id);
                    return {
                        ...group,
                        type: 'group',
                        search: `${group.group_name}`,
                        noEmails: !group.group_members.some(id => this.$store.state.batchConfig.users.find(u => u.user_id == id).user_page_email)
                    };
                }
                else {
                    return r.email;
                }
            });

            this.showTransferConfigurationEdit = true;
        },

        deleteTransferConfigClick: function(userTransferDeleteId) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete User File Transfer',
                message: `Are you sure you want to delete this user transfer?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteTransferConfig(userTransferDeleteId)
            });
        },

        deleteTransferConfig: function(userTransferDeleteId) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "userthreshold/usertransferdelete");
            this.$http.post(route, {args: {transferConfigurationId: userTransferDeleteId}}).then(response => {
                let result = response.body;
                this.getUserTransferList()
            });
        },

        saveTransferConfig: function(transferConfiguration) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "userthreshold/usertransferupdate");
            if(transferConfiguration.transfer_id == -1) {
                route = (TELSA.apiHost + "userthreshold/usertransfercreate");
            }

            // TODO: SHould hide the modal before this but it runs a connection test. Figure this out.
            this.showTransferConfigurationEdit = false;
            for(let [index, recipient] of transferConfiguration.recipients.entries()) {
                transferConfiguration.recipients[index] = {
                    user_id: recipient.user_id ? recipient.user_id : null,
                    group_id: recipient.group_id ? recipient.group_id : null,
                    email: recipient.user_id || recipient.group_id ? null : recipient
                }
            }

            this.$http.post(route, {args: {transferConfiguration: transferConfiguration}}).then(response => {
                let result = response.body;
                if(result == "invalid") {
                    TELSA.loading(false);
                    alert("File Transfer Configuration is not valid, confirm parameters are correct.");
                }
                else {
                    // this.showTransferConfigurationEdit = false;
                    this.getUserTransferList();
                }
            });
        },

        runTransferConfigClick: function(transferConfig) {
            this.selectedRunTransferConfig = transferConfig;
            this.showRunTransferConfigModal = true;
        },

        runTransferConfig: function() {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "userthreshold/usertransferrun");
            this.$http.post(route, {args: {transferConfigurationId: this.selectedRunTransferConfig.transfer_id, instant_run_date: this.instantRunDate}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
                this.showRunTransferConfigModal = false;
                this.selectedRunTransferConfig = null;
            });
        },

        cloneTransferConfigClick: function(transferConfigToClone) {
            let transferConfig = JSON.parse(JSON.stringify(transferConfigToClone));
            transferConfig.transfer_id = -1;
            this.editTransferConfig(transferConfig);
        }
    },

    mounted() {
        this.getUserTransferList();
        this.instantRunDate = TELSA.moment().format('YYYY-MM-DD');
    }

  
};
</script>

<style scoped>

    #ag-grid-container-user-transfers {
        height: calc(100vh - 126px);
        width: 100%;
    }

</style>
